/* ログ一覧検索結果リスト */
import React, { useState, memo } from 'react';
import { Grid, _ } from 'gridjs-react';
import { KeyValue } from '../types/KeyValue';
import { Props as PopsLogList } from '../types/LogList';

type Props = {
  projects: Array<KeyValue[]>;
  config: PopsLogList['config'];
};

const LogResultList: React.FC<Props> = ({ projects, config }) => {
  const [rows, setRows] = useState(10);
  const onChangeLimit = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setRows(Number(event.target.value));
  };
  return (
    <>
      <div className="row my-2">
        <div className="col-md-12">
          <span className="search-criteria-head">表示件数</span>
          <select
            name="表示件数"
            className="search-form-input"
            onChange={onChangeLimit}
            value={rows}
          >
            {config.display_list_number.map((num: number, index: number) => {
              return (
                <option key={index} value={num}>
                  {num}
                </option>
              );
            })}
          </select>
        </div>
      </div>
      <Grid
        data={projects}
        columns={[
          {
            id: 'created_at',
            name: '時間',
            width: '100px',
          },
          {
            id: 'user_id',
            name: 'ユーザ名',
            width: '80px',
          },
          {
            id: 'message_code',
            name: 'メッセージID',
            width: '80px',
          },
          {
            id: 'message',
            name: 'メッセージ',
            width: '350px',
            formatter: (cell) =>
              _(
                cell
                  ?.toString()
                  .split('\\n')
                  .map((x, index) => <div key={index}>{x}</div>)
              ),
          },
          {
            id: 'src_address',
            name: '接続情報',
            width: '110px',
          },
        ]}
        search={false}
        sort={true}
        pagination={{
          enabled: true,
          limit: rows,
        }}
        fixedHeader={true}
        height="600px"
      />
    </>
  );
};

export default memo(LogResultList);
